import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../../Common/Modal/Modal';

const ChangeDaysOutModal = ({ task, deltaDays, onCancel, onComplete }) => {
    

    const renderBody = () => {
        return (
            <div>
                <div>Are you sure you want to change the Target Days Out from {task.targetDaysOut} to {(deltaDays * -1) + task.targetDaysOut}?</div>
                {task.startDaysOut &&
                    <div>Are you sure you want to change the Start Days Out from {task.startDaysOut} to {(deltaDays * -1) + task.startDaysOut}?</div>    
                }             
            </div>
        )
    }

    return (
        <Modal
            id="ChangeDaysOutModal"
            title="Confirm Change"
            body={renderBody()}
            onCloseClick={onCancel}
            onPrimaryClick={onComplete}
            onSecondaryClick={onCancel}
        />   
    )
}

ChangeDaysOutModal.propTypes = {
    task: PropTypes.object.isRequired,
    deltaDays: PropTypes.number.isRequired,
    onCancel: PropTypes.func.isRequired,
    onComplete: PropTypes.func.isRequired
};

export default ChangeDaysOutModal;